/**
 * import alert from './alerts.js'
 *
 * Usage
 *
 * new alert().session()
 * // This is for laravel messages, call it in app.js
 *
 * new alert().response()
 * // This is for js messages.
 * // Params
 * // type = 'error' or 'success'
 * // response = string or Array
 *
 * new alert().custom()
 * // This is for js messages.
 * // Params
 * // type = 'error' or 'success'
 * // response = object eg. { title: string, content: string or Array }
 *
 * new alert().confirm()
 * // This is for html messages, , call it in app.js

 * // Example <a>
 * <a
 * alert="confirm-link"
 * alert-title="Lorem"
 * alert-content="Lorem ipsum dolor"
 * alert-continue="Continue"
 * alert-cancel="Cancel"
 * ></a>

 * // Example <form>
 * <button type="submit"
 * alert="confirm-form"
 * alert-title="Lorem"
 * alert-content="Lorem ipsum dolor"
 * alert-continue="Continue"
 * alert-cancel="Cancel"
 * ></button>
 */


 require('jquery-confirm')

 const __ = {
   'en': {
     'cancel':    'Cancel',
     'close':     'Close',
     'continue':  'Continue',
     'title': {
       'success': 'Completed',
       'error':   'Something is wrong'
     }
   },
   'es': {
     'cancel':    'Cancelar',
     'close':     'Cerrar',
     'continue':  'Continuar',
     'title': {
       'success': 'Completado',
       'error':   'Hay un problema'
     }
   }
 }
 const settings = {
   animation        : 'scale',
   backgroundDismiss: true,
   closeAnimation   : 'scale',
   smoothContent    : false,
   theme            : 'modern',
   typeAnimated     : false,
   useBootstrap     : false
 }
 const defaultButtons = {
   buttons: {
     close: {
       btnClass: 'btn--alert-close',
       text: '<span class="x:fs-22 far fa-times-circle"></span>'
     }
   }
 }

 const errorAlert = (response) => {
   let content = (response.constructor === Array) ? '<ul><li>' + response.join('</li><li>') + '</li></ul>' : response
   let options = {
     title  : __[app.locale].title.error,
     content: content,
     icon   : 'far fa-times-circle x:fs-40',
     type   : 'red',
   }

   options = $.extend(settings, options, defaultButtons)

   $.confirm(options)
 }
 const successAlert = (message) => {
   let content = (message.constructor === Array) ? '<ul><li>' + message.join('</li><li>') + '</li></ul>' : '<p>' + message + '</p>'
   let options = {
     title  : __[app.locale].title.success,
     content: content,
     icon   : 'far fa-check-circle x:fs-50',
     type   : 'green',
   }

   options = $.extend(settings, options, defaultButtons)

   $.confirm(options)
 }
 const customAlert = (type, response) => {
   let content = (response.content.constructor === Array) ? '<ul><li>' + response.content.join('</li><li>') + '</li></ul>' : response.content
   let options = {
     content: content,
     title  : response.title,
     type   : (type === 'success') ? 'green' : 'red',
   }

   options = $.extend(settings, options, defaultButtons)

   $.confirm(options)
 }
 const confirmAlert = ($alert) => {
   const btnDefaultClass = 'btn btn--large x:mrg-bt-5'

   let options = {
     title  : $alert.getAttribute('alert-title')   || '',
     content: $alert.getAttribute('alert-content') || '',
     type   : 'neutral',
     buttons: {
       cancel: {
         text: '<div>' + $alert.getAttribute('alert-cancel') || __[app.locale].cancel + '</div>',
       },
       confirm: {
         text: '<div>' + $alert.getAttribute('alert-continue') || __[app.locale].continue + '</div>',
         action: function() {
           if ($alert.getAttribute('alert') === 'confirm-form') {
             $alert.closest('form').submit()
           }
           if ($alert.getAttribute('alert') === 'confirm-link') {
             window.location.href = $alert.getAttribute('href')
           }
         }
       },
       close: {
         btnClass: 'btn--alert-close',
         text: '<span class="x:fs-22 far fa-times-circle"></span>'
       }
     }
   }

   options = $.extend(settings, options)

   $.confirm(options)
 }

 class alert {
   constructor() {
     this.dom = {
       alerts: document.querySelectorAll('[alert]')
     }
   }
   session() {
     if (app.errors.length > 0)
       errorAlert(app.errors)

     if (app.success.length > 0)
       successAlert(app.success)
   }
   response(type = null, response = null) {
     if (type === 'error')
       errorAlert(response)

     if (type === 'success')
       successAlert(response)
   }
   custom(type = null, response = {}) {
     if (Object.keys(response).length === 0)
       return false

     customAlert(type, response)
   }
   confirm() {
     if (!this.dom.alerts.length > 0)
       return false

     this.dom.alerts.forEach(($alert) => {
       $alert.addEventListener('click', (e) => {
         e.preventDefault()

         confirmAlert(e.currentTarget)
       })
     })
   }
 }

 export default alert
